import messages from './messages';
import { StateProgramSetup } from '../StateProgramSetup';
import PropertyStateConfig from '../../../PropertyStateConfig';

const NSPSetup = ({
  editMode,
  onChange,
  values,
  promptToaster,
  isLoadingPassbookRateData,
  state,
  stateConfigs,
}: Props) => {
  const nspConfig = {
    programName: 'NSP',
    titleMessage: messages.title,
    showInterimCerts: true,
    showOverrideQualification: true,
    showAnnualRecertMonth: true,
  };

  return (
    <>
      <StateProgramSetup
        editMode={editMode}
        onChange={onChange}
        values={values}
        promptToaster={promptToaster}
        isLoadingPassbookRateData={isLoadingPassbookRateData}
        config={nspConfig}
      />

      <PropertyStateConfig
        editMode={editMode}
        onChange={onChange}
        state={state}
        stateConfigs={stateConfigs}
        affordableProgramName={nspConfig.programName}
      />
    </>
  );
};

export default NSPSetup;
